module.exports = __webpack_public_path__ + "static/media/image9.9ac64362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SketchBook/image9.jpg
// module id = 1081
// module chunks = 0